import React, { useRef } from 'react';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import aiImageSVG from '../../icons/phosphor/ai-image.svg'; // eslint-disable-line import/no-unresolved

interface Props {
  pathname?: string;
}

const AIToolbarButton = ({ pathname }: Props) => {
  const hiddenRef = useRef<HTMLButtonElement>(null);
  const isContentsView = pathname?.endsWith('/contents');
  if (!isContentsView) return null;

  return (
    <>
      <Plug pluggable="main.toolbar.top" id="ai-image-btn">
        <button
          type="button"
          aria-label="Image IA"
          onClick={() => hiddenRef.current?.click()}
          tabIndex={0}
          className="ai-image"
          id="toolbar-ai-image"
        >
          <Icon name={aiImageSVG} size="30px" title="Image IA" />
        </button>
      </Plug>
      <Plug pluggable="main.toolbar.bottom" id="ai-image-hidden">
        {(props: any) => (
          <button
            ref={hiddenRef}
            type="button"
            style={{ display: 'none' }}
            onClick={(e) => props.onClickHandler(e, 'aiImage')}
            aria-hidden="true"
            tabIndex={-1}
          />
        )}
      </Plug>
    </>
  );
};

export default AIToolbarButton;
